import { render, staticRenderFns } from "./DictionaryOption.vue?vue&type=template&id=1ad6a7da&"
import script from "./DictionaryOption.vue?vue&type=script&lang=js&"
export * from "./DictionaryOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad6a7da')) {
      api.createRecord('1ad6a7da', component.options)
    } else {
      api.reload('1ad6a7da', component.options)
    }
    module.hot.accept("./DictionaryOption.vue?vue&type=template&id=1ad6a7da&", function () {
      api.rerender('1ad6a7da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/dictionary-options/DictionaryOption.vue"
export default component.exports